import { ItemPickerOption } from './itemPickerOption';

export class ItemPickerModel implements ItemPickerOption {
  constructor(
    public id: string,
    public icon: string,
    public name: string
  ) {}
}
